<template>
    <div class="Element Widget useHand" :class="{ disabled: this.disabled }">
        <div ref="dropdown" class="dropdown" v-if="this.mode == 'dropdown'">
            <button class="more-inline icon-only dropdown-toggle" :class="{active: isDropdownActive}" type="button" @click="handleDropdownClick($event)">
                <Icon name="menu" />
            </button>
            <div class="dropdown-menu" :class="{open: isDropdownActive}">
                <Widgets mode="dropdown"/>
            </div>
            <div class="bg"></div>
        </div>
    </div>
</template>

<script>
import {defineComponent, inject, ref} from "vue";

import Widgets from "elements/widgets";

import Icon from "components/icon";
import { contact, value, user_avatar } from "store/portal";
import trans from "helpers/_translation";
import { env } from "config";

export default defineComponent({
    name: "profile",
    props: {
        mode: {
            type: String,
            required: false,
            default: "dropdown"
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        Icon,
        Widgets
    },
    setup() {
        const dropdown = ref();
        const isDropdownActive = ref(false);
        const catchOutsideClick = (e, dropdown) => {
            // When user clicks menu — do nothing
            if (dropdown === e.target || dropdown.contains(e.target)) return false;

            // When user clicks outside of the menu — close the menu
            if (isDropdownActive.value && dropdown !== e.target && !dropdown.contains(e.target)) return true;
        };
        const handleDropdownClick = (e) => {
            isDropdownActive.value = !isDropdownActive.value;
            const closeListener = (e) => {
                if (dropdown?.value && catchOutsideClick(e, dropdown?.value)) {
                    window.removeEventListener('click', closeListener);
                    isDropdownActive.value = false;
                }
            };
            if (isDropdownActive.value) {
                window.addEventListener('click', closeListener);
            } else {
                window.removeEventListener('click', closeListener);
            }
        };

        return {
            env,
            dropdown,
            value,
            user_avatar,
            contact,
            handleDropdownClick,
            isDropdownActive,
            trans
        };
    },
});
</script>